import { withHandlers } from 'recompose';

export const withRef = (refId) =>
  withHandlers(() => {
    let myRef = null;
    return {
      [refId]: () => (ref) => (myRef = ref),
      ['get' + capitalize(refId)]: () => () => myRef,
    };
  });

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
